<!--
  모바일 하단 탭.

  구성은 운영페이지에서 제조사가 정하고(companyMobileTabs), 실제 노출은 여기서
  그 계정의 권한과 교집합을 내서 결정한다.

    표시할 탭 = 제조사가 고른 탭 ∩ 그 계정의 privileges

  제조사가 잘못 골라도 권한 없는 계정에는 그 탭이 나오지 않는다.
  권한 모델(privileges)은 건드리지 않으므로 덴티움 ERP 영업사원의
  readOptions(전체조회/지점전체조회/본인계정만조회) 처리도 그대로 살아 있다.

  탭이 유일한 이동 수단이므로, 대시보드를 탭에서 뺀 제조사에서는
  상단 로고를 눌러 대시보드로 돌아간다(App.vue 의 mobile-home-bar).
-->
<template>
  <nav v-if="visibleTabs.length >= MIN_TABS" class="mobile-tab-bar">
    <a
      v-for="tab in visibleTabs"
      :key="tab.menuId"
      class="mobile-tab-item"
      :class="{ active: isActive(tab.link) }"
      @click="go(tab)"
    >
      <!--
        아이콘은 비활성·활성 두 장을 겹쳐 두고 opacity 를 교차시킨다.

        한 장만 그리고 src 를 바꾸면 그림이 딱 바뀐다. 네이티브는
        UIView.transition(crossDissolve, 0.4) 로 녹이므로, 라벨만 0.4s 로 넘어가고
        아이콘은 튀어 둘이 어긋나 보인다.

        두 URL 은 서버 menus 에 이미 등록돼 있다(iconDefaultUrl / iconActiveUrl).
        새로 만들 자산도, 운영페이지에서 등록할 것도 없다.
        처음에 둘 다 받으므로, 탭을 처음 누를 때 활성 아이콘을 그제서야 받아
        한 번 깜빡이던 것도 없어진다.
      -->
      <span class="mobile-tab-icon-wrap">
        <template v-if="tab.iconDefaultUrl || tab.iconActiveUrl">
          <img
            class="mobile-tab-icon"
            :src="withIconVersion(tab.iconDefaultUrl || tab.iconActiveUrl)"
            alt=""
          />
          <img
            class="mobile-tab-icon is-active"
            :src="withIconVersion(tab.iconActiveUrl || tab.iconDefaultUrl)"
            alt=""
          />
        </template>
        <!--
          코드로 붙는 탭(브라이트몰)은 URL 이 없어 인라인 SVG 를 쓴다.

          색을 고정값으로 주는 이유: 이미지 아이콘은 파일에 색이 박혀 있어 탭 색과
          무관하게 진하기가 일정한데, currentColor 를 따라가게 두면 이 탭만 연해진다.
          이제 두 벌을 그리므로 상태를 볼 필요 없이 각자 자기 색을 갖는다.
        -->
        <template v-else-if="tab.iconSvg">
          <svg
            class="mobile-tab-icon"
            v-bind="svgAttrs"
            style="color: #2f3337"
            v-html="tab.iconSvg"
          />
          <svg
            class="mobile-tab-icon is-active"
            v-bind="svgAttrs"
            style="color: #17191c"
            v-html="tab.iconSvgActive || tab.iconSvg"
          />
        </template>
        <span v-else class="mobile-tab-icon-none" />
      </span>
      <span class="mobile-tab-text">{{ tab.menuName }}</span>
    </a>
  </nav>
</template>

<script>
import { withIconVersion } from "@/utils/menuIcon";

/*
 * 탭이 하나여도 띄운다.
 *
 * 처음에는 2개 미만이면 숨겼는데, 그러면 제조사가 탭 설정을 하기 전의 덴티움이
 * 브라이트몰(하드코딩) 하나만 남아 바가 통째로 사라진다 — 예전에는 보이던 화면이다.
 * 상단 로고로 대시보드에 갈 수 있으니 탭 하나짜리 바도 쓸모가 있다.
 */
const MIN_TABS = 1;

export default {
  name: "MobileTabBar",
  data() {
    return {
      MIN_TABS,
      // 인라인 SVG(브라이트몰) 공통 속성. 비활성·활성 두 벌을 그리므로 한 곳에 둔다.
      svgAttrs: {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": 2,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
      },
    };
  },
  computed: {
    /**
     * 그릴 탭 목록.
     *
     * 교집합·차단 필터·브라이트몰 예외는 store 의 getVisibleMobileTabs 한 곳에서
     * 계산한다. 이 컴포넌트는 그리기만 한다 — App.vue 도 같은 getter 로
     * 본문 아래 여백을 정하므로 '바는 없는데 여백만 남는' 어긋남이 없다.
     */
    visibleTabs() {
      return this.$store.getters.getVisibleMobileTabs;
    },
  },
  methods: {
    withIconVersion,
    isActive(link) {
      if (!link) return false;
      const here = this.$route.path;
      return here === link || here.startsWith(`${link}/`);
    },
    go(tab) {
      // 외부 링크(사용 가이드 등)는 새 창으로. 라우터에 없는 주소라 push 하면 404 가 된다.
      if (tab.isNewWindow === "Y" || /^https?:\/\//.test(tab.link)) {
        window.open(tab.link, "_blank", "noopener,noreferrer");
        return;
      }
      if (this.$route.path === tab.link) return;
      this.$router.push(tab.link);
    },
  },
};
</script>

<style lang="scss" scoped>
/* 이 컴포넌트는 폰 전용이다. PC 에서는 App.vue 가 아예 렌더하지 않지만,
   폭이 넓어졌을 때를 대비해 스타일도 미디어 쿼리 안에만 둔다. */
@media screen and (max-width: 767px) {
  /*
    치수·색·움직임을 네이티브 탭바에 맞춘다.
    (iOS CustomItemView / CustomTabBar, 안드로이드 TabLayout)

    네이티브 구성: 위 12 · 아이콘 · 간격 8 · 라벨 · 아래 16
    배경은 GrayListBackground(#F3F5F6) 로 페이지 배경과 같고, 경계는 그림자로만 낸다.
  */
  .mobile-tab-bar {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1030;
    display: flex;
    background: #f3f5f6;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);

    /*
      높이에 safe-area 를 '더한다'. 전역 box-sizing 이 border-box(부트스트랩 reboot)라
      높이를 고정한 채 padding 만 주면 내용 영역이 그만큼 줄어 라벨이 잘린다.
      index.html 에 viewport-fit=cover 를 붙이면서 env() 가 실제 값을 갖게 되어
      이 구분이 의미를 갖는다 — 그 전에는 항상 0 이라 티가 나지 않았다.

      값은 App.vue 의 :root 에 있다. 본문 스페이서(.mobile-tab-spacer)와
      채팅 버튼(#webchat-button-container)이 같은 값을 봐야 어긋나지 않는다.
    */
    height: calc(var(--mobile-tab-h) + env(safe-area-inset-bottom, 0px));
    padding: 12px 0 16px;
    padding-bottom: calc(16px + env(safe-area-inset-bottom, 0px));

    /*
      컴포지터 레이어로 올린다.

      안드로이드 웹뷰는 position:fixed 요소를 자기 레이어로 올려 주지 않아,
      스크롤할 때마다 메인 스레드에서 위치를 다시 계산한다. 그래서 플링 중에
      한 박자씩 밀리고 눌린 것처럼 보인다(갤럭시에서 보고된 증상).
      위 box-shadow 는 프레임당 리페인트 비용이 커서 이 승격 없이 넣으면 더 심해진다.
      iOS 는 알아서 올려 주므로 영향이 없다.
    */
    transform: translateZ(0);
    will-change: transform;
    backface-visibility: hidden;
  }

  .mobile-tab-item {
    flex: 1 1 0;
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    text-decoration: none;
    /* 네이티브: 비활성 black 40% → 활성 black 100% */
    color: rgba(0, 0, 0, 0.4);
    /*
      네이티브는 14pt 다. 그대로 쓰면 탭 5개일 때 한 칸 75px 에 글자가 안 들어가
      말줄임이 잦아진다(네이티브는 탭이 2개뿐이라 14pt 가 가능했다). 12px 로 절충한다.
      line-height 를 고정하는 이유는 위 height 계산(12+20+8+14+16)이 맞아떨어져야 해서다.
    */
    font-size: 12px;
    line-height: 14px;
    cursor: pointer;

    /* 네이티브 animateItems: 0.4s / animateClick: 0.15s 로 줄었다 돌아옴 */
    transition: color 0.4s, transform 0.15s;

    &.active {
      color: rgba(0, 0, 0, 1);
      font-weight: 600;
    }

    /* 네이티브 animateClick 의 scale 0.9. 진동(HapticService)은 웹에서 불가능해 뺀다 */
    &:active {
      transform: scale(0.9);
    }
  }

  /*
    아이콘 두 장을 같은 자리에 겹친다.
    크기는 이 상자가 잡고 아이콘은 절대배치라, 레이아웃에는 한 장 몫만 차지한다.
  */
  .mobile-tab-icon-wrap {
    position: relative;
    width: 20px;
    height: 20px;
    flex: none;
  }

  .mobile-tab-icon {
    position: absolute;
    inset: 0;
    width: 20px;
    height: 20px;
    object-fit: contain;
    /* 네이티브 UIView.transition(crossDissolve, 0.4) 과 같은 길이 */
    transition: opacity 0.4s;
  }

  /* 평소엔 비활성 장이 보이고, .active 가 붙으면 두 장의 역할이 뒤바뀐다 */
  .mobile-tab-icon.is-active {
    opacity: 0;
  }

  .mobile-tab-item.active .mobile-tab-icon {
    opacity: 0;
  }

  .mobile-tab-item.active .mobile-tab-icon.is-active {
    opacity: 1;
  }

  /* 아이콘이 아예 없는 탭의 자리 표시. 겹칠 짝이 없으므로 위 규칙을 타지 않는다 */
  .mobile-tab-icon-none {
    position: absolute;
    inset: 0;
    background: #f1f2f3;
    border-radius: 4px;
  }

  /* 탭 5개면 한 칸이 75px 다. 글자가 넘치면 줄바꿈 대신 말줄임으로 처리한다 */
  .mobile-tab-text {
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0 2px;
  }
}
</style>
